import { useState } from 'react'
import { AxiosError } from 'axios'

import { CLIENT_CODE } from '@/constants'
import { api } from '@/utils'

type Props = {
  onSuccess: (message: string) => void,
  onError: (message: string) => void
}

export type Params = {
  phone: string
}

export const useForgotPassword = ({ onSuccess, onError }: Props) => {
  const [loading, setLoading] = useState<boolean>(false)

  const submit = async (params: Params) => {
    try {
      setLoading(true)
      const body = {
        client_code: CLIENT_CODE,
        channel: 'wa',
        ...params
      }
      const res = await api.post('forgot-password', body)
      onSuccess(res.data.message)
    } catch (e: any) {
      if (e instanceof AxiosError) {
        onError(e?.response?.data?.message || (navigator.onLine ? 'Server Error' : 'Network Error'))
      }
    } finally {
      setTimeout(() => setLoading(false), 1)
    }
  }

  return { loading, submit }
}
